import { gql } from "@apollo/client";

export const GET_STUDENT_TUITION_REPORT = gql`
  query GetStudentTuitionReportPagination(
    $academicYearId: ID!
    $page: Int
    $limit: Int
    $keyword: String
    $from: String
    $to: String
  ) {
    getStudentTuitionReportPagination(
      academicYearId: $academicYearId
      page: $page
      limit: $limit
      keyword: $keyword
      from: $from
      to: $to
    ) {
      data {
        _id
        student_id
        firstName
        lastName
        englishName
        gender
        nationality
        profileImg
        dob
        phone
        customerType
        invoiceNumber
        paidDate
        startDate
        endDate
        progarmmeName
        className
        shiftName
        Income
        AdminFee
        Tuition
        TrailOneMonth
        MealService
        TransportationService
        SchoolUniform
        Material
        Music
        Computer
        Dance
        SummerClass
        Other
        total
        note
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_YEARLY_STUDENT_REGISTER_PAID_SCHOOL_FEE = gql`
  query GetYearlyAmountPaid($academicYearId: ID, $programmeId: [ID]) {
    getYearlyAmountPaid(
      academicYearId: $academicYearId
      programmeId: $programmeId
    ) {
      dataByProgramme {
        totalAmountByProgramme
        programmeName
        numberOfStudentPaidByProgramme
        dataByClassGroup {
          classGroupName
          dataByGrade {
            numberOfStudentPaidByGrade
            gradeName
            dataByClass {
              roomNumber
              numberOfStudentPaidByClass
              className
              totalStudentInClass
              totalByMonth {
                totalAmount
                numberOfStudentPaid
                monthName
              }
              totalAmountByClass
              studyShift
            }
            totalAmountByGrade
          }
          numberOfStudentPaidByClassGroup
          totalAmountByClassGroup
        }
      }
      totalNum {
        totalAmount
        numberOfStudentPaid
        monthName
      }
    }
  }
`;

export const GET_YEARLY_STUDENT_REGISTER_ENROLLMENT_BY_PROGRAMME = gql`
query GetYearlyStudentRegisterEnrollmentByProgramme($academicYearId: ID, $oldAcademicYearId: ID, $programmeId: [ID]) {
  getYearlyStudentRegisterEnrollmentByProgramme(academicYearId: $academicYearId, oldAcademicYearId: $oldAcademicYearId, programmeId: $programmeId) {
    totalData {
      totalOldAcademicYearStudent
      totalStudentByType
      totalOldStudent
      totalNewStudent
      totalReEnrollStudent
      totalAddProgrammeStudent
      totalChangeProgrammeStudent
      totalByMonth {
        yearName
        monthName
        total
      }
    }
    dataByProgramme {
      programmeName
      totalOldAcademicYear
      totalByType
      totalOldStudentByProgramme
      totalNewStudentByProgramme
      totalReEnrollStudentByProgramme
      totalAddProgrammeStudentByProgramme
      totalChangeProgrammeStudentByProgramme
      dataByClassGroup {
        classGroupName
        totalOldAcademicYearByClassGroup
        totalByTypeAndClassgroup
        totalOldStudentByClassGroup
        totalNewStudentByClassGroup
        totalReEnrollStudentByClassGroup
        totalAddProgrammeStudentByClassGroup
        totalChangeProgrammeStudentByClassGroup
        totalByMonthClassgroup {
          yearName
          monthName
          total
        }
      }
      totalByMonthProgramme {
        yearName
        monthName
        total
      }
    }
  }
}
`;

export const GET_STUDENT_ENROLLMENT_BY_CLASSGROUP = gql`
query GetStudentRegisterByClassgroupAccounting($academicYearId: ID, $oldAcademicYearId: ID, $programmeId: ID, $classgroupId: ID) {
  getStudentRegisterByClassgroupAccounting(academicYearId: $academicYearId, oldAcademicYearId: $oldAcademicYearId, programmeId: $programmeId, classgroupId: $classgroupId) {
    totalData {
      totalByOldAcademicYear
      totalByType
      totalOldStudent
      totalNewStudent
      totalReEnrollStudent
      totalAddProgrammeStudent
      totalChangeProgrammeStudent
      totalByMonth {
        yearName
        monthName
        total
      }
    }
    dataByGrade {
      gradeName
      totalByOldAcademicYear
      totalByType
      totalOldStudentByGrade
      totalNewStudentByGrade
      totalReEnrollStudentByGrade
      totalAddProgrammeStudentByGrade
      totalChangeProgrammeStudentByGrade
      dataByClass {
        className
        studyShift
        roomNumber
        totalByOldAcademicYearAndMonth
        totaByTypeAndMonth
        totalOldStudentByMonth
        totalNewStudentByMonth
        totalReEnrollStudentByMonth
        totalAddProgrammeStudentByMonth
        totalChangeProgrammeStudentByMonth
        totalByMonth {
          yearName
          monthName
          total
        }
      }
    }
  }
}
`

export const GET_MONTHLY_AMOUNT_PAID = gql`
  query GetMonthlyAmoutPaid(
    $academicYearId: ID
    $programmeId: ID
    $classgroupId: ID
    $filterYear: String
    $filterMonth: String
  ) {
    getMonthlyAmoutPaid(
      academicYearId: $academicYearId
      programmeId: $programmeId
      classgroupId: $classgroupId
      filterYear: $filterYear
      filterMonth: $filterMonth
    ) {
      totalNum {
        dayName
        totalAmount
        numberOfStudentPaid
      }
      dataByGrade {
        gradeName
        totalAmountByGrade
        numberOfStudentPaidByGrade
        dataByClass {
          className
          studyShift
          roomNumber
          totalStudentInClass
          totalAmountByClass
          numberOfStudentPaidByClass
          totalByDay {
            dayName
            totalAmount
            numberOfStudentPaid
          }
        }
      }
    }
  }
`;

export const GET_REMAINING_PAYMENT_BY_CLASS_GROUP_REPORT = gql`
  query GetRemainingPaymentByClassReport($classId: ID!, $keyword: String) {
    getRemainingPaymentByClassReport(classId: $classId, keyword: $keyword) {
      motherName
      fatherName
      motherPhone
      fatherPhone
      studentId
      studentName
      groupFeeType
      estimatedAmount
      paidAmount
      discountAmount
      amountNotPay
      invoiceIdList
      lastPaidDate
      expireDate
      paymentStatus
    }
  }
`;

export const GET_REMAINING_PAYMENT_BY_STUDENT = gql`
  query GetPaymentHistoryByStudentAndClass($classId: ID!, $studentId: ID!) {
    getPaymentHistoryByStudentAndClass(
      classId: $classId
      studentId: $studentId
    ) {
      invoiceId
      paidDate
      startDate
      endDate
      grossAmount
      discountAmount
      netAmount
    }
  }
`;
export const GET_DISBURESMENT_REPORT = gql`
  query GetDisbursementReport($fromDisNum: Int, $toDisNum: Int, $fromDate: String, $toDate: String, $accountId: String, $supplierId: String) {
  getDisbursementReport(fromDisNum: $fromDisNum, toDisNum: $toDisNum, fromDate: $fromDate, toDate: $toDate, accountId: $accountId, supplierId: $supplierId) {
    date
    disbursementNumber
    InvoiceNo
    supplier
    description
    qty
    exchangeRate
    totalPriceAsUSD
    priceUSD
    priceKHR
    accountName
    accountCode
  }
}
`;

export const GET_CASH_RECIEVING_VOUCHER = gql`
  query CashReceivingVocher(
    $fromDate: String
    $toDate: String
    $incomeType: [String]
    $incomeShiftId: String
  ) {
    cashReceivingVocher(
      fromDate: $fromDate
      toDate: $toDate
      incomeType: $incomeType
      incomeShiftId: $incomeShiftId
    ) {
      date
      listOfIncomeType {
        incomeType
        listOfInvoiceId
        accountCode
        totalAmount
      }
    }
  }
`;

export const GET_CASH_RECIEVING_VOUCHER_DETAILS = gql`
    query InvoiceListDetailReport($academicYearId: ID, $fromDate: String, $toDate: String, $incomeShiftId: String) {
  invoiceListDetailReport(academicYearId: $academicYearId, fromDate: $fromDate, toDate: $toDate, incomeShiftId: $incomeShiftId) {
    totalByIncomeType {
      totalTuition
      totalAdminFee
      totalMeal
      totalTransportation
      totalUniform
      totalMaterial
      totalGeneralProgramme
      totalSummerClass
      totalRental
      totalElectricity
      totalOther
      totalOfAll
      totalOfAllInRiels
    }
    invoiceList {
      studentId
      typeOfCustomer
      specialCase
      invoiceId
      receivedDate
      startingDate
      finishDate
      studentFullName
      studentLatinName
      sex
      birthday
      descriptionType
      englishClass
      khmerClass
      generalProgrameClass
      time
      months
      tuition
      adminFee
      meal
      transportation
      uniform
      material
      generalProgramme
      summerClass
      rental
      electricity
      other
      total
      phoneNumberFather
      phoneNumberMother
      remark
      exchangeRate
      totalInRiels
    }
  }
}
`;

export const GET_PAYMENT_BY_EXPIRED = gql`
  query GetPaymentByExpireDate(
    $academicYearId: ID
    $fromDate: String
    $toDate: String
  ) {
    getPaymentByExpireDate(
      academicYearId: $academicYearId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      studentId
      invoiceId
      expiredDate
      paidDate
      studentName
      gender
      foreignProgrammeClass
      khmerProgrammeClass
      generalProgrameClass
      typeOfPayment
      countMonth
      paidAmount
      actualAmountPaid
      phoneNumberFather
      phoneNumberMother
      other
    }
  }
`;
